import _classCallCheck from "D:\\projects\\suseval\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\projects\\suseval\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\projects\\suseval\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\projects\\suseval\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\projects\\suseval\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import _defineProperty from "D:\\projects\\suseval\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";
import { Model } from '@vuex-orm/core';

var Uzer =
/*#__PURE__*/
function (_Model) {
  _inherits(Uzer, _Model);

  function Uzer() {
    _classCallCheck(this, Uzer);

    return _possibleConstructorReturn(this, _getPrototypeOf(Uzer).apply(this, arguments));
  }

  _createClass(Uzer, null, [{
    key: "fields",
    value: function fields() {
      return {
        id: this.attr(null),
        name: this.attr(''),
        email: this.attr('')
      };
    }
  }]);

  return Uzer;
}(Model);

_defineProperty(Uzer, "entity", 'uzers');

export { Uzer as default };